<app-modal-component
  className="bk-modal--flush"
  [open]="showModal"
  [labelledBy]="title ? titleId : null"
  [label]="title ? '' : 'Dialog'"
  [closeOnBackdrop]="closeOnBackdrop"
  (dismiss)="closeModal()"
>
  <div
    [class]="
      merge(
        'mfc w-full sm:w-[90%] md:w-[500px] h-[100dvh] md:h-auto md:max-h-[90vh] overflow-hidden z-50 flex flex-col',
        className
      )
    "
    tabindex="-1"
    cdkFocusInitial
  >
    <!-- header -->
    <header class="header mfc__head">
      <h2 class="bk-heading mfc__title" [id]="titleId">{{ title }}</h2>

      <button
        type="button"
        class="closeIcon bk-icon-btn mfc__close"
        aria-label="Close"
        (click)="closeModal()"
      >
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    <div
      [class]="
        merge(
          'mfc__body mt-2 px-4 sm:px-5 flex-1 md:max-h-[80vh] overflow-y-auto',
          contentClass
        )
      "
    >
      <ng-content> </ng-content>
    </div>

    @if(showComponentFooter){
    <div class="footer mfc__foot">
      <stepper-controls
        (leftButtonClick)="leftFooterButtonClick.emit()"
        (rightButtonClick)="rightFooterButtonClick.emit()"
        [loading]="footerLoading"
        containerClass="mfc__controls bg-transparent py-3"
        [controlContainerClass]="merge('justify-end gap-2', footerClass)"
        [rightButtonDisabled]="rightFooterButtonDisabled"
        [leftButtonDisabled]="leftFooterButtonDisabled"
        [leftButtonLabel]="leftFooterButtonLabel"
        [rightButtonLabel]="rightFooterButtonLabel"
        [leftButtonClass]="leftFooterButtonClass"
        [rightButtonClass]="rightFooterButtonClass"
      />
    </div>
    }
  </div>
</app-modal-component>
